import { render, staticRenderFns } from "./ChronotachographHistory.vue?vue&type=template&id=4b2c0fad&scoped=true&"
import script from "./ChronotachographHistory.vue?vue&type=script&lang=js&"
export * from "./ChronotachographHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c0fad",
  null
  
)

export default component.exports